// extracted by mini-css-extract-plugin
export default {"footer":"Footer_footer__kXlYa","footerImage":"Footer_footerImage__uh7G5"};